import * as NavConstants from 'constants/NavConstants';
import FolderDAO from 'file-browser/FolderDAO';
import normalizeFolder from 'folders/util/normalizeFolder';
import {getSelectedPageSize} from 'nav/sidepanel/PageSizeUtil';
import * as SidepanelReduxActions from 'nav/sidepanel/SidepanelReduxActions';
import SidepanelStore from 'nav/sidepanel/SidepanelStore';
import notifications from 'notifications';
import {getStore} from 'redux-stores/Store';
import {getFilterByKey} from 'search/FilterUtil';
import {
  convertFromGraphqlSavedSearchParams,
  NonPaginatedSearchParams,
  SavedSearch,
} from 'search/saved-searches/SavedSearchUtil';
import {FilterKey, SingleValueFilter} from 'search/SearchConstants';

export async function switchToSavedSearchRegistryForRegistrySidepanel(
  savedSearch?: SavedSearch
): Promise<void> {
  // If we are trying to unload a saved search, we don't need to do anything special, so simply return.
  if (!savedSearch) {
    return;
  }

  const searchParams = convertFromGraphqlSavedSearchParams(savedSearch.searchParams);
  await switchToSavedSearchRegistryForRegistrySidepanelWithParams(searchParams);
}

export async function switchToSavedSearchRegistryForRegistrySidepanelWithParams(
  searchParams: NonPaginatedSearchParams,
  forceOpen: boolean = false
): Promise<void> {
  // If we are trying to unload a saved search, we don't need to do anything special, so simply return.
  const folderFilter = getFilterByKey(searchParams.filters, FilterKey.FOLDER) as SingleValueFilter;
  if (!folderFilter) {
    throw new Error('No registry folder filter specified for registry listing saved search.');
  }

  const currentListedFolder = SidepanelStore.getListedFolder(NavConstants.Section.REGISTRIES);
  const currentSection = SidepanelStore.getSection();
  // If the saved search is for a different registry or we are not in the REGISTRIES section,
  // we need to switch to the correct registry before loading the saved search.

  // For saved search purposes, we only need to switch folders if we are not already in the correct folder,
  // because there's another function that loads the saved search.
  // But for insertable search, we need to force the sidepanel to open on every click handler.
  if (
    forceOpen ||
    currentSection !== NavConstants.Section.REGISTRIES ||
    currentListedFolder?.api_identifier !== folderFilter.value
  ) {
    try {
      const folder = await FolderDAO.fetch(folderFilter.value!, {summary: '1'});
      if (!folder) {
        throw new Error('Registry not found');
      }

      getStore().dispatch(
        SidepanelReduxActions.listFolder(normalizeFolder(folder), {
          offset: 0,
          limit: getSelectedPageSize(),
          ...searchParams,
        })
      );
    } catch (e) {
      notifications.error(
        'Could not find registry for saved search. It may not exist or you may not have access'
      );
      throw e;
    }
  }
}
